import React, { Component } from 'react';
import { func, object, string } from 'prop-types';
import { connect } from 'react-redux';

import NotificationsViews from './views';


class Notifications extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { reader:{ ebook } } = this.props;
    let rid = '9999';

    if (ebook && ebook.rid && ebook.rid.split('-') && ebook.rid.split('-')[0]) {
      rid = ebook.rid.split('-')[0]
    }

    const viewProps = { rid };

    return <NotificationsViews { ...viewProps } />;
  }
}

NotificationsViews.propTypes = {
  reader: object
};


function mapStateToProps(state) {
  return {
    reader: state.reader
  };
}


export default connect(mapStateToProps)(Notifications);
